import React from "react";
// MUI
import {Button, Grid, Typography} from "@mui/material";
import FileCopyIcon from "@mui/icons-material/FileCopy";
// style
import {style} from "./style";
import {copyContentToClipBoard} from "../../utils/misc";

export default function QRCodeText(props: any) {

    const {fieldDisplay} = props

    let text: string = '';

    if (!!fieldDisplay.text) text = fieldDisplay.text;

    return (
        <Grid item xs={12} sx={style.mainWrapper}>
            <Typography variant={"body1"} sx={style.textTypo}>
                {text}
            </Typography>
            <Grid container justifyContent={'center'} justifyItems={'center'}>
                <Button
                    variant={'contained'}
                    sx={style.button}
                    onClick={() => copyContentToClipBoard(text)}
                >
                    <FileCopyIcon sx={style.copyIcon}/> Copy Text
                </Button>
            </Grid>
        </Grid>
    );
}
